import { Box, Button, Stack, Typography, Link as MuiLink } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Merchant } from 'src/app/api/openapi';
import { GridColDef } from '@mui/x-data-grid-premium';
import { useMemo, useRef } from 'react';
import { MerchantClient } from 'src/app/api/clients/merchants';
import CustomDataGrid from 'src/app/components/CustomDataGrid';

const Merchants = () => {
  const navigate = useNavigate();

  const cursor = useRef<string | undefined>(undefined);

  const dataSource = useMemo(
    () => ({
      getRows: () =>
        MerchantClient.catalogMerchantsListMerchants(
          'name',
          10,
          cursor.current
        ).then(({ data }) => {
          cursor.current = data.cursor;
          return {
            rows: data?.items || [],
          };
        }),
    }),
    []
  );

  const columns: GridColDef<Merchant>[] = [
    {
      field: 'name',
      headerName: 'Name',
      renderCell: ({ row }) => (
        <MuiLink component={Link} to={`./${row.merchant_id}`}>
          {row.name}
        </MuiLink>
      ),
      flex: 1,
    },
    {
      field: 'Provider',
      renderCell: ({ row }) => (
        <Box component="span" sx={{ textTransform: 'capitalize' }}>
          {row.provider}
        </Box>
      ),
      headerName: 'Provider',
      flex: 1,
    },
    {
      field: 'Address',
      renderCell: ({ row }) => (
        <span>
          {row.address.street_address || ''}, {row.address.locality || ''}{' '}
          {row.address.region || ''}, {row.address.country || ''}{' '}
          {row.address.postal_code || ''}
        </span>
      ),
      headerName: 'Address',
      flex: 1,
    },
    {
      headerName: 'ID',
      field: 'merchant_id',
      flex: 1,
    },
  ];

  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h1">Merchants</Typography>
        <Button variant="flat" onClick={() => navigate('./create')}>
          Create Merchant
        </Button>
      </Stack>
      <Stack maxHeight="80vh">
        <CustomDataGrid
          dataSource={dataSource}
          onDataSourceError={(error) => console.log(error)}
          getRowId={({ merchant_id }: Merchant) => merchant_id}
          columns={columns}
          rowCount={1} // TODO
          pagination
          paginationModel={{ page: 0, pageSize: 10 }}
        />
      </Stack>
    </>
  );
};

export default Merchants;
